// session.js: Session expiration and logout helper

export function hasSession() {
  return !!localStorage.getItem('facesToken');
}

export function isSessionExpired() {
  const expires = localStorage.getItem('facesTokenExpires');
  if (!expires) return true;
  return Date.now() > Number(expires);
}

export function logoutWithMessage(message) {
  localStorage.clear()
  sessionStorage.setItem(
    'facesSessionMessage',
    message || 'Session expired. Please log in again.'
  );
  window.location.href = '/login';
}
